import { render } from "./CrudLinkReportePorNegocio.vue?vue&type=template&id=3fc779ca"
import script from "./CrudLinkReportePorNegocio.vue?vue&type=script&lang=js"
export * from "./CrudLinkReportePorNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__